export default value => parseFloat(value.toString().replace(',', '.'))
